/* eslint-disable */
import React, {memo, useEffect, useState} from 'react';
import {selectedDaysArray} from 'routes/App/settings/constants';
import {useDeliveryHoursContext} from 'routes/App/settings/DeliveryHoursPicker/context/DaysPickerContext';
import DaysRow from 'routes/App/settings/DeliveryHoursPicker/DaysPickerDays/DaysRow';

const DaysPickerDays = ({day}) => {
  const [selectedDays, setSelectedDays] = useState(selectedDaysArray());
  const deliveryDays = useDeliveryHoursContext();

  useEffect(() => {
    const nextDays = selectedDaysArray();

    deliveryDays.forEach((day) => {
      day.days.forEach((dayName) => {
        if (Object.prototype.hasOwnProperty.call(nextDays, dayName)) {
          nextDays[dayName] = true;
        }
      });
    });

    setSelectedDays(nextDays);
  }, [deliveryDays]);

  return (
    <>
      <DaysRow selectedDays={selectedDays} day={day} />
    </>
  );
};

export default memo(DaysPickerDays);
